import * as React from 'react';
import { Select } from '@leagueplatform/genesis-core';
import type { ControlComponent } from '@web-config-app/entity-form';
import {
  EntityFormControl,
  getSelectOptionsWithPlaceholder,
} from '@web-config-app/entity-form';

export const SelectInputControl: ControlComponent = (props) => (
  <EntityFormControl
    {...props}
    renderControl={({
      data,
      handleChange,
      path,
      inputStatus,
      enabled,
      enumOptions,
      enumPlaceholder,
      required,
    }) => {
      const selectOptionsWithPlaceholder = getSelectOptionsWithPlaceholder({
        enumOptions,
        enumPlaceholder,
      });
      return (
        <Select
          value={data ?? ''}
          onChange={(evt) =>
            // if the selected value is falsey, we want to set `data` to undefined
            // as this passes ajv validation and allows for a successful clear of the
            // value in our POST/PATCH calls
            handleChange(path, evt.currentTarget.value || undefined)
          }
          inputStatus={inputStatus}
          required={required}
          disabled={!enabled}
          {...selectOptionsWithPlaceholder}
        />
      );
    }}
  />
);
